/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Sex_QuestionInputs */

const en_us2_onboarding_sex_question = /** @type {(inputs: Onboarding_Sex_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is your biological sex?`)
};

const pt_br2_onboarding_sex_question = /** @type {(inputs: Onboarding_Sex_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o seu sexo biológico?`)
};

const es_419_onboarding_sex_question = /** @type {(inputs: Onboarding_Sex_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es tu sexo biológico?`)
};

const pt_pt2_onboarding_sex_question = /** @type {(inputs: Onboarding_Sex_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o teu sexo biológico?`)
};

const fr_fr2_onboarding_sex_question = /** @type {(inputs: Onboarding_Sex_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel est ton sexe biologique ?`)
};

const de_de2_onboarding_sex_question = /** @type {(inputs: Onboarding_Sex_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist dein biologisches Geschlecht?`)
};

const it_it2_onboarding_sex_question = /** @type {(inputs: Onboarding_Sex_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è il tuo sesso biologico?`)
};

/**
* | output |
* | --- |
* | "What is your biological sex?" |
*
* @param {Onboarding_Sex_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_sex_question = /** @type {((inputs?: Onboarding_Sex_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Sex_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_sex_question(inputs)
	if (locale === "es-419") return es_419_onboarding_sex_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_sex_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_sex_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_sex_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_sex_question(inputs)
	return en_us2_onboarding_sex_question(inputs)
});
export { onboarding_sex_question as "onboarding.sex.question" }